import { baseSource } from "./base-source.js";
export const boundaryQuerySource = async function (options) {
    const { columns, filters, tilesetTableName, propertiesSqlQuery, queryParameters } = options;
    const urlParameters = {
        tilesetTableName,
        propertiesSqlQuery
    };
    if (columns) {
        urlParameters.columns = columns.join(',');
    }
    if (filters) {
        urlParameters.filters = filters;
    }
    if (queryParameters) {
        urlParameters.queryParameters = queryParameters;
    }
    return baseSource('boundary', options, urlParameters);
};
